<template>
    <div class="message-list">
        <div class="top">
            <base-divider text="缴费记录"/>
        </div>

        <div class="bottom">
            <el-table
                :data="list"
                v-loading="loading"
                size="mini"
                stripe
            >
                <el-table-column label="消息id" prop="id"></el-table-column>
                <el-table-column label="是否已读" prop="isRead">
                    <template slot-scope="scope">
                        {{scope.row.isRead ? '已读' : '未读'}}
                    </template>
                </el-table-column>
                <el-table-column label="消息类型" prop="msgType">
                    <template slot-scope="scope">
                        {{scope.row.msgType ? '系统公告' : '系统消息'}}
                    </template>
                </el-table-column>
                <el-table-column label="发送时间" prop="sendDate"></el-table-column>
                <el-table-column label="发送类型" prop="sendType">
                    <template slot-scope="scope">
                        {{scope.row.sendType ? '定时发送' : '立即发送'}}
                    </template>
                </el-table-column>
                <el-table-column label="消息标题" prop="title"></el-table-column>
            </el-table>

            <div class="pagination" center>
                <el-pagination
                        background
                        hide-on-single-page
                        layout="prev, pager, next"
                        @current-change="pageChange"
                        @prev-click="pageChange"
                        @next-click="pageChange"
                        :current-page="formMessage.currentPage"
                        :total="formMessage.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import {getMessageList} from '@/http/request'
    import BaseDivider from "../../../components/BaseDivider/BaseDivider"

    export default {
        name: "myMessageList",
        components: {BaseDivider},
        data() {
            const payStatus = {
                0: '待支付',
                1: '支付中',
                2: '已支付',
                3: '已取消',
                4: '支付失败',
                5: '已关闭',
                6: '等待扣款'
            }
            const payType = {
                0: '微信',
                1: '支付宝'
            }
            return {
                loading: false,
                payStatus,
                payType,
                list: [],
                formMessage: {
                    total: 0,
                    currentPage: 1,
                    formData: {
                        limit: 10,
                        page: 1,
                        orderField: 'payStatus'
                    }
                }
            }
        },
        computed: {
            payStatusText() {
                return (status) => this.payStatus[status]
            },
            payTypeText() {
                return (status) => this.payType[status]
            },
        },
        created() {
            this.initData();
        },
        methods: {
            // 页面初始化数据
            initData() {
                // 获取缴费记录
                this.getMessageList();
            },

            // 获取缴费记录
            getMessageList() {
                this.loading = true;
                // 查询缴费记录列表中是否存在未支付的订单，如果存在取出未支付的订单支付，如果不存在，调用欲下单接口
                getMessageList(this.formMessage.formData).then(({data}) => {
                    this.loading = false;
                    if (data.code === 0) {
                        this.list = data.data.list;
                        this.formMessage.total = data.data.total
                    } else {
                        this.$message({
                            type: 'error',
                            message: data.msg
                        })
                    }
                })
            },

            pageChange(n) {
                this.formMessage.formData.page = n;
                this.getMessageList()
            }
        }
    }
</script>

<style lang="less" scoped>
    .message-list {
        .top {
            margin-bottom: 50px;
        }
        .pagination {
            margin-top: 30px;
        }
    }
</style>